import { render, staticRenderFns } from "./roam-despatch-order-list.vue?vue&type=template&id=3e35aa7a"
import script from "./roam-despatch-order-list.vue?vue&type=script&lang=js"
export * from "./roam-despatch-order-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports